<template>
  <div class="form-element"
       :class="{'has-error': validationErrors}">
    <label class="label"
           :for="name"
           @click="open">
      <cso-button :label="label"
                  :upload-icon="true"
                  :disabled="disabled"
                  icon-alt-text="Upload"
                  modifier="light-white" />
    </label>
    <cso-info-icon v-if="hint"
                   :content="hint" />
    <p v-if="isSelected && !hideFile"
        class="uploaded-file">
      {{ fileName }}
      <i class="vf-icon vf-icon-close-big clear"
         @click="clear"
         aria-label="Schließen"
         role="img" />
    </p>
    <input type="file"
           id="name"
           name="name"
           class="input"
           ref="input"
           data-cy="upload-input"
           @input="select" />
    <div class="form-explanations">
      <span v-for="(error, index) in validationErrors"
            class="form-errorText"
            :key="index">
        {{ error.message }}
      </span>
    </div>
  </div>
</template>
<script>
import validatedInputField from '@/mixins/validatedInputField'

import CsoInfoIcon from '@/components/core/composition/CsoInfoIcon.vue'

export default {
  name: 'CsoFile',
  mixins: [validatedInputField],

  components: {
    CsoInfoIcon
  },

  props: {
    hideFile: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isSelected () {
      return !!this.modelValue
    },
    fileName () {
      return this.modelValue && this.modelValue.name
    },
    input () {
      return this.$refs.input
    }
  },

  methods: {
    open () {
      if (this.hideFile) {
        this.clear()
      }
      this.input.click()
    },
    clear () {
      this.input.value = ''
      this.$emit('update:modelValue', '')
    },
    select (event) {
      this.$emit('update:modelValue', event.target.files[0])
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  cursor: pointer;
  display: inline-block;
}
.clear {
  cursor: pointer;
}
.input {
  display: none;
}

.uploaded-file {
  padding-top: 20px;

  .vf-icon {
    padding-left: 20px;
  }
}

.form-errorText {
  @include error-message();
}
</style>
